// ============================================
// LIGA AJUPAM - Leagues Service (v6.5.0 Fase 3)
// ============================================
// Servicios relacionados con el soporte multi-liga.

import { supabase, handleSupabaseError } from './client';
import { withTimeout } from '../../utils/withTimeout';
import type { AdminLeague } from '../../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const callRpc = async (fnName: string, params: Record<string, any>): Promise<any> => {
  // Timeout: sin esto, un RPC colgado deja al boot del admin en
  // "Cargando panel…" para siempre (getMyLeagues alimenta ese loader).
  const { data, error } = await withTimeout<any>((supabase.rpc as any)(fnName, params), 15000, fnName);
  if (error) throw handleSupabaseError(error);
  return data;
};

/**
 * Devuelve la lista de ligas que el admin logueado puede administrar.
 * Consulta `admin_league_roles` vía RPC `admin_get_my_leagues`.
 *
 * Retorna array vacío si el admin no tiene ninguna liga asignada (p. ej.,
 * VENUE_ADMIN o admin creado sin asignación).
 */
export const getMyLeagues = async (
  adminSessionToken: string
): Promise<AdminLeague[]> => {
  const data = await callRpc('admin_get_my_leagues', {
    p_admin_session_token: adminSessionToken,
  });
  return (data ?? []) as AdminLeague[];
};
